(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/tooltip.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "groupValues");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("groupValue", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += " <div class=\"group-value clearfix\"> <div class=\"indicator pull-left\"> <span style=\"background: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"map")),"color"), env.opts.autoescape);
output += "\" class=\"h-charts-component-dot\"> ";
if(runtime.memberLookup((t_4),"type") == "lines") {
output += " <span class=\"h-charts-component-line\" style=\"background: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"map")),"line_color"), env.opts.autoescape);
output += "\"></span> ";
;
}
output += " </span> </div> <div class=\"group-details pull-left\"> <span class=\"value pull-left\">";
output += runtime.suppressValue(env.getFilter("hChartsNumber").call(context, runtime.memberLookup((t_4),"value"),runtime.contextOrFrameLookup(context, frame, "format")), env.opts.autoescape);
output += "</span> <span class=\"title pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"map")),"title"), env.opts.autoescape);
output += "</span> </div> </div> ";
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
